import ApiClient from '../utils/apiClient';
import requestSuccessFailureHelper from '../utils/helpers/ReduxHelper';
import { GET_VENUE_AREAS } from '../utils/constants';

export default function getVenueAreas() {
  const { action: getVenueAreasAction } = requestSuccessFailureHelper(
    GET_VENUE_AREAS,
    () => ApiClient.get('/api/v1/area/')
  );

  return dispatch => {
    dispatch(getVenueAreasAction());
  };
}



// WEBPACK FOOTER //
// ./src/actions/venueAreasActions.js